import React from "react";

// seo
import Seo from "../components/Seo";

// Components
import HeaderWithLogo from "../components/Header/HeaderWithLogo";

const Terms = props => {
  return (
    <div>
      <Seo
        title="Reverse Diabetes, Obesity & PMOS Naturally with Twin Health in India"
        description="Experience clinically proven, AI-driven program to reverse Diabetes, Hypertension, Obesity, PMOS & other chronic conditions with Twin Health now in India. 97% reduced blood sugar & medication, 98% symptom relief. Start your journey today."
      />
      <HeaderWithLogo logoPosition="center" />

      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <h1 className="text-center mb-4" style={{ fontWeight: "700" }}>
              TWIN Digital Services India Pvt Ltd – Terms of Use
            </h1>

            <div className="mb-4">
              <p className="mb-2">
                <strong>Effective Date:</strong> October 8, 2025
              </p>
            </div>

            <section className="mb-5">
              <h2 className="h4 mb-3" style={{ fontWeight: "600" }}>
                1. INTRODUCTION
              </h2>
              <p className="mb-3">
                <strong>1.1</strong> These Terms of Use and Privacy Policy
                (collectively referred to as the "Terms") constitute a legally
                binding agreement between you ("User", "you", or "your") and
                Twin Digital Services India Private Limited, a company
                incorporated under the Companies Act, 2013, having its
                registered office in India ("Twin India"), and its affiliates,
                including Twin Health, Inc. (collectively referred to as "Twin
                Health", "we", "us", or "our").
              </p>
              <p className="mb-3">
                <strong>1.2</strong> These Terms govern your access to and use
                of Twin Health's digital health platforms, mobile application,
                website, and related connected health monitoring and telehealth
                services (the "Services"). By accessing or using the Services,
                you acknowledge that you have read, understood, and agree to be
                bound by these Terms and all applicable laws and regulations. If
                you do not agree, you must discontinue use of the Services
                immediately.
              </p>
              <p className="mb-3">
                <strong>1.3</strong> Twin Health operates in compliance with the
                applicable laws of India, including the Digital Personal Data
                Protection Act, 2023 (DPDP Act), Telemedicine Practice
                Guidelines, 2020, and, where applicable, U.S. HIPAA standards
                for Protected Health Information (PHI).
              </p>
              <p className="mb-3">
                <strong>This document is structured as follows:</strong>
              </p>
              <ul className="mb-3">
                <li>a) Medical Policy & Consent</li>
                <li>b) Twin Service Policy</li>
                <li>c) Privacy Policy</li>
                <li>d) Terms of Use</li>
                <li>e) Annexures</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3" style={{ fontWeight: "600" }}>
                2. MEDICAL POLICY & CONSENT
              </h2>
              <h3 className="h5 mb-3" style={{ fontWeight: "600" }}>
                2.1 Medical Consent (Telemedicine)
              </h3>
              <p className="mb-3">
                By signing the medical consent (digitally or physically), you
                acknowledge and agree as follows:
              </p>
              <p className="mb-3">
                <strong>2.1.1 Language and Understanding:</strong> The nature,
                purpose, and potential risks of the procedures and
                teleconsultation services have been explained to me in a
                language I understand: ____________________.
              </p>
              <p className="mb-3">
                <strong>2.1.2 Consent to Telehealth:</strong> I hereby consent
                to receive remote medical consultation and health management
                services through Twin Health's digital platforms, including all
                data processing and sharing as per the Privacy Policy.
              </p>
              <p className="mb-3">
                <strong>2.1.3 Scope of Consent:</strong> I authorize the
                attending healthcare professional(s) to perform or attempt
                additional procedures or interventions deemed necessary in their
                professional judgment during the course of treatment.
              </p>
              <p className="mb-3">
                <strong>2.1.4 Alternatives and Risks:</strong> I acknowledge
                that alternative treatment options, potential benefits, and
                reasonably foreseeable risks have been explained to me. I have
                received explanations and understand that the proposed
                telehealth treatment has certain material risks/complications
                and I have been provided with their quite information about the
                same, including that there are other undefined, unanticipated,
                unexplainable risks/complications that may occur during or after
                the proposed treatment/intervention.
              </p>
              <p className="mb-3">
                <strong>2.1.5 No Guarantee:</strong> I understand after full
                explanation and the opportunity for discussion that despite best
                efforts there can be no assurance about the results or outcome
                of the proposed treatment/intervention. I confirm that I have
                not been given any guarantee or warranty about the results or
                outcome of the proposed treatment/intervention.
              </p>
              <p className="mb-3">
                <strong>2.1.6 Clarifications:</strong> I confirm that the
                Provider has answered all my questions to my satisfaction
                regarding the proposed treatment/intervention and the medical
                teams involved.
              </p>
              <p className="mb-3">
                <strong>2.1.7 Right to Second Opinion:</strong> I have been
                advised of my own election to seek and obtain a second opinion
                from another doctor regarding the proposed
                treatment/intervention.
              </p>
              <p className="mb-3">
                <strong>2.1.8 Right to Withdraw:</strong> I understand that I
                have the right to refuse treatment or to withdraw my consent at
                any time. I understand that if I do refuse treatment, the
                consequences of my decision have been explained to me. I confirm
                that after explanation, discussion, counselling and disclosures
                I have had ample time to provide consent.
              </p>
              <p className="mb-3">
                <strong>2.1.9 Voluntary Consent:</strong> This consent has been
                given voluntarily, without coercion or undue influence.
              </p>
              <p className="mb-3">
                <strong>Note:</strong> All teleconsultations shall be conducted
                in accordance with the Telemedicine Practice Guidelines, 2020
                and any subsequent amendments issued by the Medical Council of
                India or relevant authority.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3" style={{ fontWeight: "600" }}>
                3. TWIN SERVICE POLICY
              </h2>

              <h3 className="h5 mb-3" style={{ fontWeight: "600" }}>
                3.1 Devices and Sensors
              </h3>
              <p className="mb-3">
                <strong>3.1.1</strong> Users are responsible for procuring and
                maintaining approved third-party devices (such as CGM sensors,
                fitness trackers, BP monitors, and body composition scales)
                required for the program.
              </p>
              <p className="mb-3">
                <strong>3.1.2</strong> Twin Health shall not be liable for any
                inaccuracy, malfunction, or operational failure of third-party
                devices.
              </p>
              <p className="mb-3">
                <strong>3.1.3</strong> Continuous Glucose Monitor (CGM) users
                are required to upload readings daily via the designated portal
                or email (e.g., remote@twinhealth.com). Approximately six (6)
                CGM patches are expected to be used annually unless medically
                indicated otherwise.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                3.2 Laboratory Work and Diagnostics
              </h3>
              <p className="mb-3">
                <strong>3.2.1</strong> Blood and diagnostic tests shall be
                conducted at baseline and at approximately 90-day intervals
                thereafter.
              </p>
              <p className="mb-3">
                <strong>3.2.2</strong> Users shall ensure that all laboratory
                results are shared with Twin Health to facilitate clinical
                monitoring.
              </p>
              <p className="mb-3">
                <strong>3.2.3</strong> A representative list of test parameters
                is provided in Annexure A.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                3.3 Virtual Assistance and Support
              </h3>
              <p className="mb-3">
                <strong>3.3.1</strong> Routine technical and sensor-related
                assistance will be rendered by the Twin Service Assistant (TSA)
                via virtual channels.
              </p>
              <p className="mb-3">
                <strong>3.3.2</strong> Any escalation or unresolved issue may be
                directed to care@twinhealth.com.
              </p>

              <p className="mb-3 mt-4">
                <strong>DISCLAIMER:</strong> I understand this program is a No
                Refund Policy and I agree that I will fully comply to the
                program guidelines and instructions for my journey
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-center" style={{ fontWeight: "700" }}>
                4. TWIN Digital Services India Pvt Ltd – Terms of Use
              </h2>
              <p className="mb-3">
                Welcome, and thank you for your interest in Twins Digital
                Services India Private Limited ("Twin", "we", "our," or "us").
                These Terms of Use ("Terms") govern your ("you", "your", or
                "User") access to our website http://www.twinhealth.com (the
                "Site"), our mobile application (the "App"), and all related
                platforms, including databases, software, widgets, and other
                applications (collectively, the "Platform"), as well as the
                services offered via the Platform (each a "Service",
                collectively, the "Services"). The Services include healthcare
                consultations provided by registered Medical Practitioners,
                guidance from Health Coaches, and supply of medications,
                devices, and diagnostics from third-party providers.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                4.1. General
              </h3>
              <p className="mb-3">
                <strong>4.1.1 Purpose of the Platform:</strong> The Platform
                provides clinical decision support to Medical Practitioners and
                facilitates Services aimed at managing Type II Diabetes Mellitus
                and other chronic diseases, including prevention of chronic
                conditions. Twin is not your healthcare provider and does not
                offer medical advice or treatment directly.
              </p>
              <p className="mb-3">
                <strong>4.1.2 Eligibility to Use the Platform:</strong> The
                Platform is intended for users diagnosed with an Applicable
                Disease. If referred by a Medical Practitioner, you will have
                been assessed for suitability. If registering independently, a
                Medical Practitioner will conduct an initial consultation to
                determine eligibility and explain the Services. Any questions or
                dissatisfaction regarding the Platform or Services should first
                be addressed with your Medical Practitioner. If unresolved, you
                may use the 'Call Coach' feature on the Platform.
              </p>
              <p className="mb-3">
                <strong>4.1.3 Agreement Scope:</strong> These Terms, the Privacy
                Policy, and other applicable policies—including those from
                third-party providers on the Platform—constitute a legally
                binding contract between you, Twin, Medical Practitioners,
                Health Coaches, and relevant third parties regarding your use
                of the Services.
              </p>
              <p className="mb-3">
                <strong>4.1.4 Acceptance of Terms:</strong> By accessing or
                using the Platform, including clicking "I Accept", downloading
                the App, or using the Services, you agree to these Terms and our
                policies, as updated from time to time. Continued use of the
                Platform constitutes acceptance of the then-current Terms.
              </p>
              <p className="mb-3">
                <strong>4.1.5 Non-Emergency Disclaimer:</strong> The Platform
                and Services are not intended for emergencies. In medical
                emergencies, contact emergency services or visit a registered
                Medical Practitioner. The Platform is also limited to Applicable
                Diseases and does not substitute for other medical care.
              </p>
              <p className="mb-3">
                <strong>4.1.6 Modification of Terms:</strong> Twin may modify
                these Terms at its discretion. The version posted on the Site or
                App governs your use. Continued access after modifications
                constitutes acceptance of the updated Terms.
              </p>
              <p className="mb-3">
                <strong>4.1.7 Platform License:</strong> The App is licensed,
                not sold, on an "as-is" basis. Twin's liability is limited as
                described herein. Third-party fees (e.g., data, SMS, MMS) are
                your responsibility.
              </p>
              <p className="mb-3">
                <strong>4.1.8 Account Termination:</strong> You may delete your
                account at any time. Twin may suspend or withdraw Services
                without notice. No Service is guaranteed to be available 24/7.
              </p>
              <p className="mb-3">
                <strong>4.1.9 Legal Compliance:</strong> These Terms comply with
                Indian laws, including:
              </p>
              <ul className="mb-3">
                <li>a) Indian Contract Act, 1872</li>
                <li>b) Information Technology Act, 2000</li>
                <li>c) Drugs and Cosmetics Act, 1940 & Rules 1945</li>
                <li>
                  d) Drugs and Magic Remedies (Objectionable Advertisements)
                  Act, 1954
                </li>
                <li>e) National Medical Commission Act, 2019</li>
                <li>f) Pharmacy Act, 1948</li>
              </ul>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                4.2 Use of Our Services
              </h3>
              <p className="mb-3">
                <strong>4.2.1 Eligibility</strong>
              </p>
              <p className="mb-3">
                By using the Platform, you represent and warrant that:
              </p>
              <ul className="mb-3">
                <li>
                  a) You are at least 18 years old and legally competent to
                  enter into a contract.
                </li>
                <li>
                  b) You have not been suspended or removed from the Service.
                </li>
                <li>c) You comply with applicable laws and regulations.</li>
                <li>d) You provide truthful and accurate information.</li>
                <li>
                  e) You are physically located in a jurisdiction where Twin
                  provides Services.
                </li>
              </ul>
              <p className="mb-3">
                Twin reserves the right to refuse access or terminate accounts
                at its discretion.
              </p>
              <p className="mb-3">
                <strong>4.2.2 Platform Suitability:</strong> Medical
                Practitioners may determine that the Platform is unsuitable for
                certain users based on health conditions or treatment
                requirements. In such cases, you may be advised to seek
                in-person care. Eligibility may change over time; you can
                re-register if circumstances change.
              </p>
              <p className="mb-3">
                <strong>4.2.3 Accounts and Registration:</strong> Some features
                are available without registration. For full access, you must
                create an account and maintain the confidentiality of your
                credentials. Notify Twin immediately at care@twinhealth.com if
                your account is compromised. Twin is not liable for losses due
                to unauthorized access resulting from your negligence.
              </p>
              <p className="mb-3">
                <strong>4.2.4 Prohibited Conduct</strong>
              </p>
              <p className="mb-3">You agree not to:</p>
              <ul className="mb-3">
                <li>
                  a) Compete with Twin or use the Platform for illegal purposes.
                </li>
                <li>b) Defame, harass, or infringe on the rights of others.</li>
                <li>
                  c) Upload content that is unlawful, obscene, or offensive.
                </li>
                <li>d) Interfere with Platform security or operations.</li>
                <li>e) Gain unauthorized access to Platform systems.</li>
                <li>f) Engage in fraudulent activity or impersonation.</li>
                <li>g) Sell or transfer Platform access or Twin Materials.</li>
              </ul>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                4.3 Mobile Software
              </h3>
              <p className="mb-3">
                <strong>4.3.1 Usage License:</strong> Twin grants a
                non-exclusive, non-transferable, revocable license to use the
                Mobile Software for personal use. You must comply with all
                applicable laws and Carrier charges. You may not modify,
                distribute, or reverse-engineer the Mobile Software.
              </p>
              <p className="mb-3">
                <strong>4.3.2 SMS/Text Messaging Services:</strong> By using the
                Platform, you consent to receive account notifications, alerts,
                and promotional messages via SMS/text. Standard charges apply.
                Reply STOP to unsubscribe; a final confirmation may be sent.
              </p>
              <p className="mb-3">
                <strong>4.3.3 App Store-Sourced Software:</strong> Apple or
                Google Play Store provides the platform for distribution. Your
                agreement for the Mobile Software is with Twin; Apple/Google are
                third-party beneficiaries without liability for Twin's software.
              </p>
              <p className="mb-3">
                <strong>4.3.4 Data Protection:</strong> Data collected from
                third-party sensors (e.g., glucose, heart rate, sleep, BMI) is
                protected under HIPAA standards.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                4.4 Telemedicine Services and Consent
              </h3>
              <p className="mb-3">
                <strong>4.4.1 Telemedicine Definition:</strong> Services may
                involve remote consultations via electronic communications with
                a Medical Practitioner. These services have potential benefits
                and risks.
              </p>
              <p className="mb-3">
                <strong>4.4.2 Consent:</strong> By using the Services, you
                authorize Medical Practitioners to provide telehealth services.
                You may withdraw consent anytime, but Twin may suspend or
                terminate access in such cases. You acknowledge alternative
                treatment options and associated risks have been explained.
              </p>
              <p className="mb-3">
                <strong>4.4.3 Risks of Telemedicine:</strong> Risks may include:
              </p>
              <ul className="mb-3">
                <li>
                  a) Insufficient information for healthcare decisions (e.g.,
                  poor image quality).
                </li>
                <li>b) Delays due to technical failures.</li>
                <li>
                  c) Incomplete access to health records, potentially causing
                  medical errors.
                </li>
                <li>d) Security breaches despite implemented safeguards.</li>
              </ul>
              <p className="mb-3">
                <strong>4.4.4 Acknowledgment:</strong> You understand that no
                specific results are guaranteed. Telemedicine may not be
                appropriate for all medical needs.
              </p>
              <p className="mb-3">
                <strong>4.4.5 Reporting Non-Compliance:</strong> You agree to
                report any non-compliance with laws, ethical guidelines, or
                Telemedicine Guidelines encountered during consultations.
              </p>
              <p className="mb-3">
                <strong>4.4.6 Medical Practitioner Contract:</strong> Your use
                of the Platform is also governed by agreements between you and
                your Medical Practitioner.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                4.5 Privacy Policy
              </h3>
              <p className="mb-3">
                Twin understands and respects the importance of maintaining the
                confidentiality and privacy of your personal and health-related
                information. We encourage you to carefully read our Privacy
                Policy, which is available on our website, for a detailed
                explanation of how we collect, use, store, and disclose your
                personal data. By accessing or using the Platform, you
                acknowledge that you have read, understood, and accepted the
                Privacy Policy, in addition to any other privacy notices or
                agreements that may apply. This acknowledgment constitutes your
                consent to the collection, use, and sharing of your information
                as described in our Privacy Policy, and you agree to be bound by
                its provisions.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                5. Pricing, Charges, and Payment Terms
              </h3>
              <p className="mb-3">
                <strong>
                  5.1 Health Plan and Employer Provider Pricing and Payment
                  Terms:
                </strong>{" "}
                If you are a health plan member, or an employee accessing the
                Platform through your employer, the pricing, charges, and
                payment terms applicable to you will be governed by a separate
                agreement between Twin and your health plan or employer. You
                acknowledge that such pricing and payment terms are established
                exclusively by that agreement and not by the general Terms.
              </p>
              <p className="mb-3">
                <strong>5.2 Individual Pricing and Payment Terms:</strong> If
                you are using the Platform independently or through your Medical
                Practitioner outside of a health plan or employer arrangement,
                you agree to pay all applicable fees as specified in your
                account or communicated online. Twin may introduce new services
                for additional fees or revise the fees for existing services.
                Any changes to pricing or payment terms will become effective in
                the billing cycle following notification of such changes. You
                agree to pay all fees directly to Twin in accordance with the
                published terms and timelines.
              </p>
              <p className="mb-3">
                <strong>5.3 Fees:</strong> Payment of fees entitles you to
                access and use the Platform and its Services for the period
                covered by your payment. Fees may be payable in full or in
                instalments as specified at the time of registration or
                subsequently communicated. Your continued access to the Platform
                is conditional upon timely payment of all applicable fees. Twin
                reserves the right to suspend or deny access to any Service in
                the event of delayed or non-payment.
              </p>
              <p className="mb-3">
                <strong>5.4 Refunds:</strong> You may cancel your account or any
                Service by providing written notice to care@twinhealth.com.
                Except as explicitly provided under applicable law, no refunds
                will be issued for cancellations. If Twin suspends or terminates
                your account for a valid reason, including but not limited to
                violation of these Terms, you acknowledge that you will not be
                entitled to any refund.
              </p>
              <p className="mb-3">
                <strong>5.5 Access and Connectivity:</strong> You are solely
                responsible for maintaining suitable hardware, software, and
                internet connectivity required to access and use the Platform,
                at your own cost and risk. Twin reserves the right to modify
                technical requirements, access configurations, or other
                operational parameters at its discretion without prior notice.
              </p>
              <p className="mb-3">
                <strong>5.6 Medical Equipment:</strong> Certain Services may
                require the use of medical equipment or supplies prescribed by
                your Medical Practitioner, including but not limited to diabetic
                testing supplies. Such equipment and supplies must be sourced by
                you either through the Platform or via third-party vendors. All
                aspects relating to the timing, quantity, fees, and terms of
                medical equipment are determined solely by the Medical
                Practitioner.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                6. User Content
              </h3>
              <p className="mb-3">
                <strong>6.1 User Content Generally:</strong> The Platform may
                allow users, Medical Practitioners, or Twin to input, upload, or
                publish content, including messages, reviews, images, videos,
                data, or other materials (collectively "User Content"). By
                contributing User Content, you acknowledge that this content may
                be visible or accessible to other users in accordance with the
                Platform's functionality.
              </p>
              <p className="mb-3">
                <strong>6.2 Limited License Grant to Twin:</strong> By posting
                or publishing User Content on the Platform, you grant Twin a
                worldwide, non-exclusive, royalty-free license, with the right
                to sublicense, to use, host, store, display, reproduce, perform,
                modify, distribute, and otherwise exploit your content in
                connection with the Platform and the Services, in any media now
                known or later developed, without the obligation to compensate
                you or provide attribution.
              </p>
              <p className="mb-3">
                <strong>6.3 Limited License Grant to Other Users:</strong> By
                sharing User Content with other users, you grant each recipient
                a non-exclusive license to access and use the content as
                permitted by these Terms and by the Platform's features.
              </p>
              <p className="mb-3">
                <strong>
                  6.4 User Content Representations and Warranties:
                </strong>{" "}
                You represent and warrant that you are the creator or rightful
                owner of all User Content you post, or that you have obtained
                all necessary rights, permissions, or licenses to post such
                content. You further represent that your content does not
                violate any third-party rights, including intellectual property,
                privacy, publicity, or other proprietary rights, and that it
                does not contain defamatory, offensive, or unlawful material.
                You acknowledge that you are solely responsible for your User
                Content and the consequences of posting or sharing it.
              </p>
              <p className="mb-3">
                <strong>6.5 User Content Disclaimer:</strong> Twin is not
                obligated to monitor or edit User Content and disclaims any
                liability for content posted by users. Twin may, in its sole
                discretion, remove or block content that violates these Terms or
                is otherwise objectionable. You understand that exposure to User
                Content may involve offensive, inaccurate, or objectionable
                material and agree to waive any claims against Twin relating to
                such content. Twin expressly prohibits copyright infringement
                and does not endorse any User Content.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                7. Intellectual Property Violation
              </h3>
              <p className="mb-3">
                We respect the rights of third parties in their intellectual
                property. If you have an intellectual property rights-related
                complaint about material posted on the Platform, you may contact
                us at the following address: Twins Digital Services India
                Private Limited, Millenia Business Park – Phase 2, Symbyont
                Smart Spaces, Campus 5, 8th Floor, 143, Dr. MGR Road, Perungudi,
                Kandanchavadi, Chennai, Tamil Nadu, India – 600096. E-mail:
                care@twinhealth.com. Any notice alleging that materials hosted
                by or distributed through the Service infringe intellectual
                property rights must include the following information:
              </p>
              <ul className="mb-3">
                <li>
                  a. an electronic or physical signature of the person
                  authorized to act on behalf of the owner of the copyright or
                  other right being infringed;
                </li>
                <li>
                  b. a description of the copyright-protected work or other
                  intellectual property right that you claim has been infringed;
                </li>
                <li>
                  c. a description of the material that you claim is infringing
                  and where it is located on the Platform;
                </li>
                <li>d. your address, telephone number, and email address;</li>
                <li>
                  e. a statement by you that you have a good-faith belief that
                  the use of those materials on the Service is not authorized by
                  the copyright owner, its agent, or the law; and
                </li>
                <li>
                  f. a statement by you that the above information in your
                  notice is accurate and that, under penalty of perjury, you are
                  the copyright or intellectual property owner or authorized to
                  act on the copyright or intellectual property owner's behalf.
                </li>
              </ul>
              <p className="mb-3">
                <strong>7.2 Repeat Violations:</strong> Twin will promptly
                terminate without notice the accounts of users that are
                determined by Twin to be a "repeat violator." A repeat violator
                is a user who has been notified of infringing activity or has
                had User Content removed from the Platform at least twice.
              </p>
              <p className="mb-3">
                <strong>7.3</strong> Nothing contained in this clause may be
                perceived as a limitation to the ability of Twin to suspend user
                accounts for user content violations in the first instance.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                8. Third-Party Services and Linked Websites
              </h3>
              <p className="mb-3">
                The Platform may include third-party content, services, or
                websites. Twin does not control these third parties and
                disclaims liability for their accuracy, availability, legality,
                or functionality. Users access third-party services at their own
                risk and must comply with the applicable terms and privacy
                policies of such third parties.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                9. Termination of Use; Discontinuation and Modification of the
                Service
              </h3>
              <p className="mb-3">
                <strong>9.1</strong> The Platform may also allow you to display,
                use, include or make available content, data, information,
                applications or materials from third parties, including, without
                limitation, content, data, information, applications or
                materials ("Third Party Materials"). By requesting an import of
                Third-Party Materials, you agree that we may import that
                information from the applicable third-party service.
              </p>
              <p className="mb-3">
                <strong>9.2</strong> Twin may also provide tools through the
                Platform that enable you to export information, including User
                Content, to third-party services. By requesting an export of
                information, including User Content, to third-party services,
                you agree that we may export that information to the applicable
                third-party service. Third-party services are not under our
                control, and we are not responsible for any third-party
                service's use of information you provide or information you
                export or disclose.
              </p>
              <p className="mb-3">
                <strong>9.3</strong> When you use any Third Party Materials or
                third-party services, you do so at your own risk and you
                understand and agree that you are solely responsible for
                reading, understanding, and complying with any terms of use
                and/or privacy policies that apply to such third parties' terms
                of use and privacy policy. The Platform may also contain links
                to third-party websites. Linked websites are not under our
                control, and we are not responsible for their content.
              </p>
              <p className="mb-3">
                <strong>9.4</strong> Twin is not responsible or liable for the
                availability, reliability, content, functions, accuracy,
                legality, appropriateness, services, materials or any other
                aspect of such Third-Party Materials or third-party websites
                that link to or from the Service or are otherwise referenced on
                the Platform.
              </p>
              <p className="mb-3">
                <strong>9.5</strong> Twin also does not accept any
                responsibility for technical failures or for unauthorized access
                of user transmissions by any third parties. If you choose to use
                Third Party Materials and third-party websites together with the
                Platform, such use is entirely at your discretion and risk.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                10. Additional Terms
              </h3>
              <p className="mb-3">
                Your use of the Platform is subject to all additional terms,
                policies, rules, or guidelines applicable to the Platform or
                certain features of the Platform that we may post on or link to
                from the Service (the "Additional Terms"), such as end-user
                license agreements for any downloadable software applications,
                or rules that are applicable to a particular feature or content
                on the Platform. All Additional Terms are incorporated by this
                reference into, and made a part of, these Terms.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                11. Modification of these Terms
              </h3>
              <p className="mb-3">
                We reserve the right, at our sole discretion, to change or
                update these Terms from time to time. Please check these Terms
                periodically for changes or updates. Immaterial modifications
                are effective upon publication. If a change or update to these
                Terms materially modifies your rights or obligations, we will
                update the "last updated" date at the top of this page and make
                reasonable efforts to notify you that material changes have been
                made to the Terms. Your continued use of the Platform after any
                such change or update constitutes your acceptance of the new
                Terms. If you do not agree to any of these Terms or any future
                Terms, do not use or access (or continue to access) the
                Platform.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                12. Ownership; Proprietary Rights
              </h3>
              <p className="mb-3">
                The visual interfaces, trademarks, graphics, names, logos,
                marks, content (other than User Content), design, compilation,
                information, data, computer code (including source code or
                object code), products, software, services, and all other
                elements of the Service ("Twin Materials") are the intellectual
                property of Twin Inc. and are protected by intellectual property
                and other laws. All Twin Materials contained in the Platform and
                all trademarks, service marks, patents, copyrights and any and
                all other intellectual property rights and proprietary material
                related thereto are, and will remain, the exclusive property of
                Twins Digital Health Services India Private Limited and Twin
                Health Inc. or our third-party licensors. Except as expressly
                authorized by Twins Digital Health Services India Private
                Limited and Twin Health Inc, you may not copy, republish, post,
                display, translate, transmit, reproduce, distribute or otherwise
                make use of the Twin Materials. The information displayed on the
                Platform is for your personal use only. Twin Inc. reserves all
                rights to the Twin Materials not granted expressly in these
                Terms. If at any time, you make any submissions, including but
                not limited to suggestions, feature ideas, bug reports,
                comments, you assign all rights in these submissions to us. We
                shall be entitled to use such submissions for any purpose,
                whatsoever, without compensation to the maker. In any event,
                such submissions are not and will not be treated as confidential
                and we will not be liable for any disclosure of submissions.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                13. No Medical Advice
              </h3>
              <p className="mb-3">
                We act as a technology platform to connect you with Medical
                Practitioners who may be available to provide you with certain
                non-emergency medical care, however Twin is not itself a
                healthcare provider, and the Medical Practitioners are solely
                responsible for providing you with any medical care and
                treatment you receive in connection with your use of the
                Service. We do not manage, control or interfere with the
                practice of medicine by the Medical Practitioners, each of whom
                is responsible for the professional medical services he or she
                provides. The information provided by Twin as part of the Twin
                Materials and through the Platform is for general informational
                purposes only. None of the Twin Materials should be considered
                medical advice or an endorsement, representation or warranty
                that any particular medication or treatment is safe,
                appropriate, or effective for you.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                14. Indemnity
              </h3>
              <p className="mb-3">
                You agree that you will be responsible for your use of the
                Platform, and you agree to defend and indemnify Twin from and
                against every claim, liability, damage, loss, and expense,
                including reasonable attorneys' fees and costs, arising out of
                or in any way connected with: (a) your access to, use of, or
                alleged use of, the Platform; (b) your violation of any portion
                of these Terms, any representation, warranty, or agreement
                referenced in these Terms or any applicable law or regulation;
                (c) your violation of any third-party right, including any
                intellectual property right or publicity, confidentiality, other
                property, or privacy right; or (d) any dispute or issue between
                you and any third party. We reserve the right, at our own
                expense, to assume the exclusive defence and control of any
                matter otherwise subject to indemnification by you (without
                limiting your indemnification obligations with respect to that
                matter), and in that case, you agree to cooperate with our
                defence of that claim.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                15. Non-Secure Communications
              </h3>
              <p className="mb-3">
                Twin is required to comply with applicable healthcare privacy
                and security laws and maintain safeguards to protect the
                security of your health information. Additionally, the
                information you provide to your Medical Practitioner during a
                medical consultation is legally confidential, except for certain
                legal exceptions. We devote considerable effort toward ensuring
                that your personal information is secure. Information regarding
                our use of health and other personal information is provided in
                our Privacy Policy and Notice of Privacy Practices, currently
                available on our website. As part of providing you the Services,
                we will communicate to you via email and text message. Email and
                text messages are not secure methods of communication and Twin
                cannot ensure the security or confidentiality of messages sent
                by email and/or text message. Information, including personal
                health information, transmitted by email or text message is not
                encrypted and could be read by a third party. If you would
                prefer not to exchange personal health information via email or
                text message, please notify us at PrivacyIndia@TwinHealth.com.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                16. Disclaimers; No Warranties
              </h3>
              <p className="mb-3">
                WHILE THE PLATFORM FACILITATES ACCESS TO CERTAIN MEDICAL
                PRACTITIONERS FOR NON-EMERGENCY MEDICAL CARE, TWIN IS NOT A
                HEALTHCARE PROVIDER AND CANNOT AND DOES NOT DIAGNOSE OR TREAT
                YOUR HEALTH CONDITIONS. TWIN PROVIDES NO ENDORSEMENT,
                REPRESENTATION OR WARRANTY THAT ANY PARTICULAR MEDICATION OR
                TREATMENT USED BY THE MEDICAL PRACTITIONERS IS OR WILL BE SAFE,
                EFFECTIVE OR APPROPRIATE FOR YOU. DO NOT USE THE PLATFORM OR
                SERVICES FOR MEDICAL EMERGENCIES. IF YOU THINK YOU MAY HAVE A
                MEDICAL EMERGENCY, CALL THE CONTACT NUMBER FOR EMERGENCY
                SERVICES IN YOUR REGION IMMEDIATELY. THE PLATFORM AND ALL TWIN'
                MATERIALS AND ALL CONTENT AVAILABLE THROUGH THE SERVICE ARE
                PROVIDED "AS IS" AND ON AN "AS AVAILABLE" BASIS, WITHOUT
                WARRANTY OR CONDITION OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO
                THE EXTENT ALLOWED BY LAW, TWIN DISCLAIM ALL WARRANTIES OF ANY
                KIND, WHETHER EXPRESS OR IMPLIED, RELATING TO THE PLATFORM AND
                ALL TWIN MATERIALS AND CONTENT AVAILABLE THROUGH THE PLATFORM,
                INCLUDING: (A) ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS
                FOR A PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, OR
                NON-INFRINGEMENT; AND (B) ANY WARRANTY ARISING OUT OF COURSE OF
                DEALING, USAGE, OR TRADE. TWIN DO NOT WARRANT THAT THE PLATFORM
                OR ANY PORTION OF THE SERVICE, OR ANY TWIN MATERIALS OR CONTENT
                OFFERED THROUGH THE PLATFORM, WILL BE UNINTERRUPTED, SECURE, OR
                FREE OF ERRORS, VIRUSES, OR OTHER HARMFUL COMPONENTS, AND DO NOT
                WARRANT THAT ANY OF THOSE ISSUES WILL BE CORRECTED. YOU ASSUME
                ALL RISK FOR ANY DAMAGE THAT MAY RESULT FROM YOUR ACCESS TO, USE
                OR MISUSE OF, OR INABILITY TO USE THE PLATFORM, YOUR DEALINGS
                WITH ANY MEDICAL PRACTITIONER OR OTHER USER, AND ANY TWIN
                MATERIALS OR ALL CONTENT AVAILABLE THROUGH THE PLATFORM. YOU
                UNDERSTAND AND AGREE THAT YOU USE THE PLATFORM, AND ACCESS,
                DOWNLOAD, OR OTHERWISE OBTAIN TWIN MATERIALS OR CONTENT THROUGH
                THE PLATFORM AND ANY ASSOCIATED SITES OR PATFORM, AT YOUR OWN
                DISCRETION AND RISK, AND THAT YOU ARE SOLELY RESPONSIBLE FOR ANY
                DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER SYSTEM OR
                MOBILE DEVICE USED IN CONNECTION WITH THE PLATFORM), OR THE LOSS
                OF DATA THAT RESULTS FROM THE USE OF THE PLATFORM OR THE
                DOWNLOAD OR USE OF THAT MATERIAL OR CONTENT. SOME JURISDICTIONS
                MAY PROHIBIT A DISCLAIMER OF WARRANTIES AND YOU MAY HAVE OTHER
                RIGHTS THAT VARY FROM JURISDICTION TO JURISDICTION. TO THE
                EXTENT THAT WE MAY NOT DISCLAIM ANY IMPLIED WARRANTY, THE SCOPE
                AND DURATION OF SUCH WARRANTY WILL BE THE MINIMUM PERMITTED BY
                LAW.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                17. Limitation of Liability
              </h3>
              <p className="mb-3">
                IN NO EVENT WILL TWIN BE LIABLE TO YOU FOR ANY INDIRECT,
                INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES
                (INCLUDING DAMAGES FOR LOSS OF PROFITS, GOODWILL, OR ANY OTHER
                INTANGIBLE LOSS) ARISING OUT OF OR RELATING TO YOUR ACCESS TO OR
                USE OF, OR YOUR INABILITY TO ACCESS OR USE, THE PLATFORM OR ANY
                TWIN MATERIALS OR CONTENT ON THE PLATFORM, INCLUDING BUT NOT
                LIMITED TO ANY MEDICAL ADVICE OR TREATMENT BY THE MEDICAL
                PRACTITONER, WHETHER BASED ON WARRANTY, CONTRACT, TORT
                (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, AND
                WHETHER OR NOT TWIN HAS BEEN INFORMED OF THE POSSIBILITY OF
                DAMAGE. ABSENT OUR GROSS NEGLIGENCE OR WILLFUL MISCONDUCT, YOU
                AGREE THAT THE AGGREGATE LIABILITY OF TWIN TO YOU, FOR ALL
                CLAIMS ARISING OUT OF, OR RELATING TO, THE USE OF OR ANY
                INABILITY TO USE, ANY PORTION OF THE PLATFORM OR OTHERWISE UNDER
                THESE TERMS, WHETHER IN CONTRACT, TORT, OR OTHERWISE, IS LIMITED
                TO THE GREATER OF: (A) THE AMOUNT TWIN HAS RECEIVED FOR YOUR
                ACCESS TO AND USE OF THE PLATFORM IN THE TWELVE MONTHS PRIOR TO
                THE CLAIM; OR (B) TEN THOUSAND RUPEES (Rs 10,000). TWIN SHALL IN
                NO EVENT BE LIABLE TO YOU (OR TO ANY THIRD PARTY CLAIMING UNDER
                OR THROUGH THE YOU) FOR ANY INDIRECT, SPECIAL, INCIDENTAL,
                CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF, OR
                INABILITY TO USE THE PLATFORM. THESE EXCLUSIONS APPLY TO ANY
                CLAIMS FOR LOST PROFITS, LOST DATA, LOSS OF GOODWILL, WORK
                STOPPAGE, COMPUTER FAILURE OR MALFUNCTION, OR ANY OTHER
                COMMERCIAL DAMAGES OR LOSSES, EVEN IF TWIN KNEW OR SHOULD HAVE
                KNOWN OF THE POSSIBILITY OF SUCH DAMAGES, BECAUSE SOME STATES OR
                JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR THE LIMITATION OF
                LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, IN SUCH
                STATES OR JURISDICTIONS, OUR LIABILITY SHALL BE LIMITED TO THE
                EXTENT PERMITTED BY LAW EACH PROVISION OF THESE TERMS THAT
                PROVIDES FOR A LIMITATION OF LIABILITY, DISCLAIMER OF
                WARRANTIES, OR EXCLUSION OF DAMAGES IS TO ALLOCATE THE RISKS
                UNDER THESE TERMS BETWEEN YOU AND TWIN. THIS ALLOCATION IS AN
                ESSENTIAL ELEMENT OF THE BASIS OF THE BARGAIN BETWEEN US. EACH
                OF THESE PROVISIONS IS SEVERABLE AND INDEPENDENT OF ALL OTHER
                PROVISIONS OF THESE TERMS. THE LIMITATIONS IN THIS SECTION WILL
                APPLY EVEN IF ANY LIMITED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                18. Disagreements between Users
              </h3>
              <p className="mb-3">
                You alone are responsible for your communications, interactions,
                agreements, representations, promises or any other involvement
                with other Users. Twin reserves the right, but has no
                obligation, to monitor disagreements between you and other
                Users. If you have a dispute with one or more Users, you
                irrevocably and forever release Twin from claims, demands and
                damages (actual and consequential) of every kind and nature,
                known and unknown, arising out of or in any way connected with
                such disputes.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                19. Insurance Services
              </h3>
              <p className="mb-3">
                Twin is not registered with the Insurance Regulatory and
                Development Authority of India (IRDAI) to carry on the business
                of general insurance and is not in the insurance business.
                However, your Medical Practitioner and/or a the organization
                your Medical Practitioner is affiliated to may be registered
                with IRDAI to carry on the business of general insurance and
                would be required to comply with the provisions of the Insurance
                Act 1938, Insurance Regulatory and Development Act, 1999 and
                Insurance Amendment Act, 2015 and rules, regulations and any
                other order and circular issued thereunder and any other
                applicable laws of India and therefore a Medical Practitioner or
                the entity your Medical Practitioner is affiliated to and/or
                Twin may be subject to certain regulatory requirements. Please
                check with your Medical Practitioner as to usage and disclosure
                of information. Twin may be a "business associate" of the
                Medical Practitioner, and as a result, as and to the extent Twin
                is in fact a "business associate" of Medical Practitioners,
                Twin's use and disclosure of your information will be limited as
                and to the extent permitted by applicable law and regulations,
                which may include, for example, providing you with certain
                communications via emails, text messages or in app messages that
                contain information, such as appointment reminders,
                encouragement, and advice. If you would prefer not to exchange
                information via email or text message, please notify us at
                PrivacyIndia@TwinHealth.com. You may also request we update,
                correct, or delete your information by contacting us at
                PrivacyIndia@TwinHealth.com; provided however, that we may
                retain any information that we are required to maintain in
                accordance with applicable law and regulations. We regularly
                review our compliance with our Privacy Policy. When we receive
                formal written complaints, we will contact the person who made
                the complaint to follow up. We work with the appropriate
                regulatory authorities, including local data protection
                authorities, to resolve any complaints regarding the transfer of
                personal data that we cannot resolve with our users directly.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                20. Forums and Interactive Services
              </h3>
              <p className="mb-3">
                There may be interactive services within the Platform such as
                blogs, chat rooms, forums, instant messaging etc., and other
                service member zones that allow them to input their data,
                details, materials, comments or other similar communications.
                Using such services on the Platform, the User should realize
                that they are open for wide access and review, and any personal
                data that he/she published or provided during registration may
                become viewable by third parties. Twin is not responsible for
                the security of the User's information that is passed by the
                User to third parties or provided during use of such services.
                Materials that will be placed by the User in such areas of the
                Platform will be stored in systems/devices of Twin as per Twin's
                policy, if otherwise not directly documented in each particular
                case.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                21. Governing Law
              </h3>
              <p className="mb-3">
                These Terms are governed by the laws of the India without regard
                to conflict of law principles. If a lawsuit or court proceeding
                is permitted under these Terms, you and Twin agree to submit to
                the personal and exclusive jurisdiction of courts in Chennai for
                the purpose of litigating any dispute. We also agree that Twin
                may seek interim equitable relief in any court having
                jurisdiction. We deliver the Service from our offices in India,
                and we make no representation that Twin Materials included in
                the Service are appropriate or available for use in other
                locations.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                22. General
              </h3>
              <p className="mb-3">
                These Terms and any Additional Agreements are the entire and
                exclusive understanding and agreement between you and Twin
                regarding your use of the Platform. You may not assign or
                transfer these Terms or your rights under these Terms, in whole
                or in part, by operation of law or otherwise, without our prior
                written consent. We may assign these Terms at any time without
                notice or consent. The failure to require performance of any
                provision will not affect our right to require performance at
                any other time after that, nor will a waiver by us of any breach
                or default of these Terms, or any provision of these Terms, be a
                waiver of any subsequent breach or default or a waiver of the
                provision itself. Use of section headers in these Terms is for
                convenience only and will not have any impact on the
                interpretation of any provision. If any part of these Terms is
                held to be invalid or unenforceable, the unenforceable part will
                be given effect to the greatest extent possible, and the
                remaining parts will remain in full force and effect. Upon
                termination of these Terms, any provision that by its nature or
                express terms should survive, will survive.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                23. Dispute Resolution and Arbitration
              </h3>
              <p className="mb-3">
                <strong>23.1 Generally:</strong> In the interest of resolving
                disputes between you and Twin in the most expedient and
                cost-effective manner, you and Twin agree that every dispute
                arising in connection with these Terms (including those
                involving others) will be resolved by binding arbitration,
                except as noted below. Our agreement to arbitrate disputes
                includes all claims arising out of or relating to any aspect of
                these Terms, whether based in contract, tort, statute, fraud,
                misrepresentation, or any other legal theory, and regardless of
                whether a claim arises during or after the termination of these
                Terms.
              </p>
              <p className="mb-3">
                <strong>23.2 Exceptions:</strong> We both agree that nothing in
                these Terms will be deemed to waive, preclude, or otherwise
                limit the right of either of us to: (a) bring an individual
                action under the Consumer Protection Act prior to demanding
                arbitration as set forth below; (b) timely pursue an enforcement
                action through the applicable federal, state, or local agency if
                that action is available; (c) seek injunctive relief in a court
                of law at any time; or (d) to file suit in a court of law to
                address an intellectual property infringement claim at any time.
              </p>
              <p className="mb-3">
                <strong>23.3 Arbitrator:</strong> Any arbitration between you
                and Twin will be governed by Arbitration and Conciliation Act,
                1996.
              </p>
              <p className="mb-3">
                <strong>23.4 Notice:</strong> Anyone who intends to seek
                arbitration must first send a written notice of the dispute to
                the other, by certified mail or Federal Express (signature
                required), or if we do not have a physical address on file for
                you, by electronic mail ("Notice"). The address for Notice to
                Twin is Twins Digital Services India Private Limited, Millenia
                Business Park – Phase 2, Symbyont Smart Spaces, Campus 5, 8th
                Floor, 143, Dr. MGR Road, Perungudi, Kandanchavadi, Chennai,
                Tamil Nadu, India – 600096
              </p>
              <p className="mb-3">
                <strong>23.5 Demand:</strong> The Notice must: (a) describe the
                nature and basis of the claim or dispute; and (b) set forth the
                specific relief sought ("Demand"). We each agree to use good
                faith efforts to resolve the claim directly, but if we do not
                reach an agreement to do so within 30 days after the Notice is
                received, you or Twin may commence an arbitration proceeding.
                The litigants will have the ability to take discovery on and
                exchange relevant information, on a confidential basis, about
                the dispute. During the arbitration, the amount of any
                settlement offers made by you or Twin must not be disclosed to
                the arbitrator until after the arbitrator makes a final,
                decision and award, if any. Except as required to comply with
                law or other obligations, the arbitration proceedings, filings
                and outcome shall be confidential.
              </p>
              <p className="mb-3">
                <strong>23.6 Fees:</strong> Any arbitration hearing will take
                place at a Chennai. If the arbitrator finds that either the
                substance of your claim or the relief sought in the Demand is
                frivolous or brought for an improper purpose, you agree to
                reimburse Twin for all monies previously disbursed by Twin.
              </p>
              <p className="mb-3">
                <strong>23.7 Modifications:</strong> If Twin makes any future
                change to this arbitration provision (other than a change to
                Twin's address for Notice), you may reject the change by sending
                us written notice within 30 days of the change to Twin's address
                for Notice, in which case your account with Twin will be
                immediately terminated and this arbitration provision, as in
                effect immediately prior to the amendments you reject will
                survive.
              </p>
              <p className="mb-3">
                <strong>23.8 Enforceability:</strong> If any portion of Section
                23 is found to be unenforceable, then Twin can elect to construe
                the entirety of this Section 23 to be null and void and, but in
                any event, we each agree that the exclusive jurisdiction and
                venue provisions will govern any action arising out of or
                related to these Terms.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                24. Consent to Electronic Communications
              </h3>
              <p className="mb-3">
                You consent to receive electronic communications from Twin in
                accordance with the Privacy Policy, which will satisfy legal
                requirements for written notice.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                25. Contact Information
              </h3>
              <p className="mb-3">
                All correspondence may be addressed to Twins Digital Services
                India Pvt Ltd, Millenia Business Park – Phase 2, Symbyont Smart
                Spaces, Campus 5, 8th Floor, 143, Dr. MGR Road, Perungudi,
                Chennai, Tamil Nadu – 600096 or emailed to care@twinhealth.com.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                26. Individual Results May Vary
              </h3>
              <p className="mb-3">
                Patient outcomes depend on several factors including duration of
                disease, health status, program adherence, and lifestyle
                factors.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                27. WBDT Technology Disclaimer
              </h3>
              <p className="mb-3">
                Twin does not claim that its Whole-Body Digital Twin ("WBDT")
                technology cures or permanently reverses diabetes. The Platform
                aims to help members improve health, manage diabetes, and
                enhance vitality.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                28. Consultation Recording and Service Interruption Notice
              </h3>
              <p className="mb-3">
                Health Counsellor consultations may be recorded for training and
                quality purposes. Reasonable efforts will be made to provide
                advance notice of scheduled service interruptions, including
                maintenance, repairs, or upgrades. In case of unforeseen
                interruptions, service will be restored promptly. Twin or the
                healthcare provider shall not be liable for losses or damages
                arising from interruptions, except in cases of wilful misconduct
                or gross negligence.
              </p>

              <h3 className="h5 mb-3 mt-4" style={{ fontWeight: "600" }}>
                29. Annexure
              </h3>
              <p className="mb-3">
                Upon enrolment, you will be provided with a list of required
                sensors and blood test parameters as part of your health
                assessment. You will need to procure these items independently.
                Your care team will provide the detailed list and guidance
                following the completion of your comprehensive health
                investigations.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
